import { Home } from "./GuardProtect";

const HomeRoutes = {
  path: "*",
  guard: Home,
};

export default HomeRoutes;
